import { render, staticRenderFns } from "./ListUmpd.vue?vue&type=template&id=bf9ad7ce&"
import script from "./ListUmpd.vue?vue&type=script&lang=js&"
export * from "./ListUmpd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports